import React from 'react';
import { ApolloConsumer, compose } from 'react-apollo';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Group from '@material-ui/icons/Group';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import SearchBar from '../../../components/SearchBar/SearchBar';
import { getUsers } from '../schema/user-schema.graphql';
import UserOverviewTable from './UserOverviewTable';
import { withSearch } from '../../../context/SearchResultsContext';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
});

const searchKey = 'user-overview';

class UserOverview extends React.Component {
  state = {
    page: 0,
    rowsPerPage: 5,
  };

  render() {
    const { classes, history, getSearchResults, setSearchResults } = this.props;
    const { loading } = this.state;

    return (
      <ApolloConsumer>
        {client => (
          <div className={classes.root}>
            <Card>
              <CardHeader icon stats>
                <CardIcon color="rose">
                  <Group />
                </CardIcon>
              </CardHeader>
              <CardBody>
                <div style={{ maxWidth: 480, margin: '40px auto' }}>
                  <SearchBar
                    initialQuery={getSearchResults().query}
                    onRequestSearch={async value => {
                      this.setState({ loading: true });
                      const { data } = await client.query({
                        fetchPolicy: 'network-only',
                        query: getUsers,
                        variables: { query: value },
                      });
                      setSearchResults(value, data.users);
                      this.setState({ loading: false });
                    }}
                    loading={loading}
                  />
                </div>
                <UserOverviewTable
                  users={getSearchResults().results}
                  onUserClick={id => history.push(`/users/${id}`)}
                />
              </CardBody>
            </Card>
          </div>
        )}
      </ApolloConsumer>
    );
  }
}

UserOverview.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const enhance = compose(
  withSearch(searchKey),
  withStyles(styles)
);

export default enhance(UserOverview);



// WEBPACK FOOTER //
// ./src/views/users/components/UserOverview.jsx